var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Repeater',{attrs:{"value":_vm.value || [],"control":{
    options: {
      repeaterOptions: {
        titleTemplate: 'Class .{name}',
        buttonName: 'Add Class',
        defaultNewValue: {
          name: 'my-class',
          template: 'yes'
        }
      }
    }
  }},on:{"input":function($event){return _vm.updateClasses($event)}},scopedSlots:_vm._u([{key:"default",fn:function({ index: repeaterIndex, value }){return [_c('b',[_vm._v("Class Name")]),_c('v-text-field',{attrs:{"value":value.name,"rules":[_vm.htmlClassNameRule]},on:{"input":function($event){return _vm.updateName(repeaterIndex, $event)}}}),_c('b',[_vm._v("Class Condition Twig Template")]),_c('CodeInput',{attrs:{"value":value.template,"language":"html"},on:{"input":function($event){return _vm.updateValue(repeaterIndex, $event)}}}),_c('div',{staticClass:"mt-2"},[_vm._v(" The template can run Twig code. Properties like design.something.whatever are available. If the template returns a blank string, the class will not be added. If the template returns anything, the class will be added. ")]),_c('div',[_vm._v("(the returned value is trimmed for spaces and newlines)")])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }